import getDynamicItemFor from "./DynamicItemMapper";
import React from "react";
import { DangerButton, SecondaryButton } from "../../../components/CustomButton";
import CustomIcon from "../../../components/CustomIcon";
import { getUiBreadCrumbFormat } from "../dynamicUiFunctions";

const DynamicSelectedItem = ({ showActions, item, onMoveUp,
  onMoveDown, onDelete, isFirst, isLast, hidden = false, mobile, onSearch,...props }) => {

  return (
    <div className={`${showActions ? 'bg-rand-300 pb-4 ' : ''}w-full relative${hidden ? ' hidden' : ''}`} {...props}>
      {item.is_quickee && (
        <div className="absolute left-[-0.8rem] top-0 bottom-0 w-8 bg-purple-500 flex items-center justify-center z-10">
          <div className="text-white text-xs font-bold transform rotate-[-90deg] leading-none">
            QUICKEE
          </div>
        </div>
      )}
      <div className="pl-4">
        <div className={`${showActions ? '' : 'hidden '}transition-all duration-1000 bg-rand-100 -mb-2 app-top-mg p-2 text-white text-sm flex justify-between items-center`}>
          <div className="whitespace-normal pr-0.5">{getUiBreadCrumbFormat(item.section)}</div>
          <div className="flex space-x-2">
            <SecondaryButton title="Search" isIconButton={true}
              onClick={onSearch}>
              <CustomIcon icon="search" />
            </SecondaryButton>
            <SecondaryButton title="Move downwards" isIconButton={true}
              disabled={isLast}
              onClick={onMoveDown}>
              <CustomIcon icon="arrow_downward" />
            </SecondaryButton>
            <SecondaryButton title="Move upwards" isIconButton={true} disabled={isFirst}
              onClick={onMoveUp}>
              <CustomIcon icon="arrow_upward" />
            </SecondaryButton>
            <DangerButton title="Remove" isIconButton={true} color="text-error-500"
              onClick={onDelete}>
              <CustomIcon icon="delete" />
            </DangerButton>
          </div>
        </div>
      </div>
      {getDynamicItemFor(item.section, { key: `selected-item-${item.id}`, mobile: mobile })}
    </div>
  );
};

export default React.memo(DynamicSelectedItem);
